// extracted by mini-css-extract-plugin
export var address = "AddressVerificationModal_address__0YUB3";
export var button = "AddressVerificationModal_button__EwsN3";
export var closeButton = "AddressVerificationModal_closeButton__opS2y";
export var container = "AddressVerificationModal_container__Bol1v";
export var content = "AddressVerificationModal_content__s9AKT";
export var highlighted = "AddressVerificationModal_highlighted__LCKAK";
export var link = "AddressVerificationModal_link__9x6Bo";
export var modal = "AddressVerificationModal_modal__1P-dp";
export var options = "AddressVerificationModal_options__HgTyj";
export var subtitle = "AddressVerificationModal_subtitle__lAMFJ";
export var suggestion = "AddressVerificationModal_suggestion__rOLHz";
export var title = "AddressVerificationModal_title__OG5TE";
export var wrapper = "AddressVerificationModal_wrapper__fYE8X";